<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.Messages'
}
</script>

<style scoped>

</style>
